import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Modal, Form, Input, message } from "antd";
import { handleUploadSign } from "../../../../api/users";
import { useState } from "react";
import { CheckCircleFilled, DeleteOutlined } from "@ant-design/icons";
import getBase64 from "../../../../utils/getBase64";

export default function UploadSign({ isVisible, setVisible, selected }: any) {
    const queryClient = useQueryClient();
    const [isSelected, setIsSelected] = useState(false);
    const [selectedFile, setSelectedFile]: any = useState(null);
    const [form] = Form.useForm();

    const changeHandler = (event: any) => {
        setSelectedFile(event.target.files[0]);
        setIsSelected(true);
    };

    const { mutate, isPending } = useMutation({
        mutationFn: handleUploadSign,
        onSuccess: () => {
            message.success("Uploaded Successfully");
            clearImage();
            queryClient.invalidateQueries({ queryKey: ["claimers"] });
            setVisible(false);

        },
        onError: () => {
            message.error("Something went wrong");
            setVisible(false);

        },
    });

    const onSubmit = async () => {

        let base64 = null;

        if (selectedFile) {
            base64 = await getBase64(selectedFile);
        }

        const data = {
            sign: base64,
        };


        await mutate({ email: selected?.email, data });
    };

    const clearForm = async () => {
        form.resetFields();
        form.setFieldsValue({ file: null });
        setSelectedFile(null);
        setIsSelected(false);
    };
    const clearImage = async () => {
        form.resetFields();
        form.setFieldsValue({ file: null });
        setSelectedFile(null);
        setIsSelected(false);
    };

    return (
        <Modal
            open={isVisible}
            title="Upload Signature"
            onCancel={() => setVisible(false)}
            footer={[
                <Button key="back" onClick={clearForm}>
                    Clear
                </Button>,
                <Button
                    key="submit"
                    form="uploadSignature"
                    htmlType="submit"
                    type="primary"
                    onSubmit={onSubmit}
                    loading={isPending}
                >
                    {isPending ? "Submiting..." : "Submit"}
                </Button>,
            ]}
        >
            <Form
                id="uploadSignature"
                form={form}
                name="normal_login"
                className="login-form"
                onFinish={onSubmit}
                layout="vertical"
            >
                <div className="flex flex-col justify-center items-center bg-gray-100 h-32 rounded-md border">
                    <div className="flex flex-col justify-center items-center">
                        {isSelected ? (
                            <div className="flex flex-col justify-center items-center">
                                <CheckCircleFilled color={"#16a34a"} size={30} />
                                <div className="text-gray-600 mt-2">Image Selected</div>
                                <div className="text-gray-500">{selectedFile?.name}</div>
                                <button
                                    className="text-red-200 flex items-center hover:text-red-500"
                                    onClick={() => clearImage()}
                                >
                                    <DeleteOutlined /> <span className="mx-1">Remove</span>
                                </button>
                            </div>
                        ) : (
                            <Form.Item
                                name="file"
                                label="Upload Signature ( Optional )"
                                rules={[
                                    {
                                        required: false,
                                        message: "Please select file",
                                    },
                                ]}
                            >
                                <Input
                                    type="file"
                                    placeholder="Signature"
                                    onChange={changeHandler}
                                />
                            </Form.Item>
                        )}
                    </div>
                </div>
            </Form>
        </Modal>
    );
}
